import { useEffect, useState } from 'react';

import { getUsersByIds } from '../services/users';
import { userLabel } from '../components/users/UserChip';
import { normalizeId } from '../utils/ids';

/**
 * `{ id: display name }` for the accounts a value menu names (KPR-1640), read
 * once when `enabled` (the menu opens) and kept for the life of the surface.
 * Until an account is read it has no entry, and the menu says "Person"; a
 * failed read leaves it that way - a name is a label, never needed to filter.
 */
export default function useAccountNames(ids, enabled) {
	const [names, setNames] = useState({});
	const key = (ids || []).join(',');
	useEffect(() => {
		if (!enabled || !key) return undefined;
		const wanted = key.split(',').filter(id => !names[id]);
		if (!wanted.length) return undefined;
		let live = true;
		getUsersByIds(wanted).then((users) => {
			if (!live || !Array.isArray(users)) return;
			setNames(known => users.reduce((out, user) => ({ ...out, [normalizeId(user?._id)]: userLabel(user) }), known));
		}).catch(() => {});
		return () => { live = false; };
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [enabled, key]);
	return names;
}
